/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Autofill_UndoInputs */

const en_directory_submit_autofill_undo = /** @type {(inputs: Directory_Submit_Autofill_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const zh_directory_submit_autofill_undo = /** @type {(inputs: Directory_Submit_Autofill_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Directory_Submit_Autofill_UndoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_undo = /** @type {((inputs?: Directory_Submit_Autofill_UndoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_UndoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_undo(inputs)
	return zh_directory_submit_autofill_undo(inputs)
});
export { directory_submit_autofill_undo as "directory.submit.autofill_undo" }